import { render } from "./KeyAccess.vue?vue&type=template&id=7184d1f1&scoped=true"
import script from "./KeyAccess.vue?vue&type=script&lang=js"
export * from "./KeyAccess.vue?vue&type=script&lang=js"

import "./KeyAccess.vue?vue&type=style&index=0&id=7184d1f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7184d1f1"]])

export default __exports__